import { Link } from 'react-router-dom';
import { movies } from '@/mocks/data';
import MovieCard from '@/components/base/MovieCard';

export default function FeaturedSection() {
  const featured = movies.filter((m) => m.featured).slice(0, 4);

  if (featured.length === 0) return null;

  const mainMovie = featured[0];
  const restMovies = featured.slice(1, 4);

  return (
    <section className="py-10 md:py-14 bg-background-900/50">
      <div className="w-full max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-50 font-heading">精选推荐</h2>
            <p className="text-sm text-foreground-500 mt-1">编辑精选，口碑最佳日韩电影</p>
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-4 md:gap-6">
          <div className="lg:col-span-1">
            <Link
              to={`/article/${mainMovie.slug}`}
              className="group block cursor-pointer"
              onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
            >
              <div className="relative overflow-hidden rounded-xl h-[400px] md:h-[480px]">
                <img
                  src={mainMovie.coverImage}
                  alt={`${mainMovie.title} - 日韩电影免费在线观看`}
                  title={`${mainMovie.title} ${mainMovie.titleEn} 在线观看`}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-background-950/95 via-background-950/30 to-transparent"></div>

                <div className="absolute top-3 left-3 flex items-center gap-2">
                  <span className="px-2 py-1 text-xs font-bold bg-primary-500 text-background-950 rounded">
                    精选
                  </span>
                  <span className="px-2 py-1 text-xs bg-background-950/70 text-foreground-200 rounded">
                    {mainMovie.year}
                  </span>
                </div>

                <div className="absolute top-3 right-3 flex items-center gap-1 bg-background-950/70 px-2 py-1 rounded-lg">
                  <i className="ri-star-fill text-xs text-accent-500"></i>
                  <span className="text-xs font-bold text-accent-400">{mainMovie.rating}</span>
                </div>

                <div className="absolute bottom-0 left-0 right-0 p-5">
                  <h3 className="text-xl font-bold text-foreground-50 mb-1 font-heading">{mainMovie.title}</h3>
                  <p className="text-sm text-foreground-400 mb-2">{mainMovie.titleEn} | 导演：{mainMovie.director}</p>
                  <p className="text-xs text-foreground-500 line-clamp-2 mb-3">{mainMovie.description}</p>
                  <div className="flex flex-wrap gap-1.5">
                    {mainMovie.tags.map((tag) => (
                      <span key={tag} className="px-2 py-0.5 text-xs bg-primary-500/20 text-primary-400 rounded-full">
                        {tag}
                      </span>
                    ))}
                  </div>
                </div>

                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <div className="w-16 h-16 rounded-full bg-primary-500/90 flex items-center justify-center shadow-lg">
                    <i className="ri-play-fill text-2xl text-background-950 ml-1"></i>
                  </div>
                </div>
              </div>
            </Link>
          </div>

          <div className="lg:col-span-2 grid grid-cols-1 sm:grid-cols-3 gap-3 md:gap-4">
            {restMovies.map((movie) => (
              <MovieCard
                key={movie.id}
                slug={movie.slug}
                title={movie.title}
                titleEn={movie.titleEn}
                coverImage={movie.coverImage}
                rating={movie.rating}
                year={movie.year}
                category={movie.category}
                region={movie.region}
                tags={movie.tags}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}